import { render } from "./createMailing.html?vue&type=template&id=4a28e5e4&scoped=true&ts=true&external"
import script from "./CreateMailing.vue?vue&type=script&lang=ts"
export * from "./CreateMailing.vue?vue&type=script&lang=ts"

import "./CreateMailing.vue?vue&type=style&index=0&id=4a28e5e4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a28e5e4"]])

export default __exports__